<template>
    <div class="inOne-records">
        <form>
            <div class="inOne-TabRecords"> 
                <h3 class="headTitle">主诉</h3>
                <el-input type="textarea" v-model="diagnose.mainSuit" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h3 class="headTitle">现病史</h3>
                <el-input type="textarea" v-model="diagnose.hpi" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h3 class="headTitle">既往辅助检查</h3>
                <el-input type="textarea" v-model="diagnose.assistantExamination" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h3 class="headTitle">刻下</h3>
                <el-input type="textarea" v-model="diagnose.kexia" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h3 class="headTitle">舌苔</h3>
                <el-input type="textarea" v-model="diagnose.shetai" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h3 class="headTitle">脉象</h3>
                <el-input type="textarea" v-model="diagnose.pulseCondition" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
            </div>

            <div class="zhenduan">
                <!-- <h4>诊断</h4> -->
                <h5 class="westernMedicine">西医诊断</h5>
                <el-input type="textarea" v-model="diagnose.wdiagnosisResult" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="1、2、3、4、5"></el-input>
                <h5 class="westernMedicine">中医诊断</h5>
                <h5>病症名：</h5>
                <el-input v-model="diagnose.mdiseasesZh" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h5>英文病症名：</h5>
                <el-input v-model="diagnose.mdiseasesEn" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
                <h5>证型：</h5>
                <el-input v-model="diagnose.mdiagnosisResult" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"></el-input>
            </div>
        </form>
 
        <div class="inOne-TabBttom">
            <el-button v-if='exhibition' @click="futureSave()" type="warning"><i class="fa fa-floppy-o"></i>保存</el-button>
            <el-button v-else @click="saveData()" type="primary"><i class="fa fa-floppy-o"></i>保存</el-button>
            <el-button @click="resetData()" type="danger" style="border-radius: 10px;"><i class="fa fa-pencil" aria-hidden="true"></i>重置</el-button>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {  
        repetitionId:0,       // 第二次提交保存id
        uData:null,           // 用户数据对象
        exhibition:false,     // 数据展示
        diagnose: {           // 诊断
          "patientId": 0,
          "doctorId": 0,
          "assistantExamination": "",
          "hpi": "",
          "kexia": "",
          "mainSuit": "",
          "mdiagnosisResult": "",
          "mdiseasesEn": "",
          "mdiseasesZh": "",
          "pulseCondition": "",
          "shetai": "",
          "wdiagnosisResult": ""
        }
      };
    },
    methods: {
      futureSave(){
        let that = this;
        that.$axios({
            url: "/api/inquiry/medicalrecord/" + that.repetitionId,
            method: "PUT",
            data: {
              "assistantExamination": that.diagnose.assistantExamination,
              "hpi": that.diagnose.hpi,
              "kexia": that.diagnose.kexia,
              "mainSuit": that.diagnose.mainSuit,
              "mdiagnosisResult": that.diagnose.mdiagnosisResult,
              "mdiseasesEn": that.diagnose.mdiseasesEn,
              "mdiseasesZh": that.diagnose.mdiseasesZh,
              "pulseCondition": that.diagnose.pulseCondition,
              "shetai": that.diagnose.shetai,
              "wdiagnosisResult": that.diagnose.wdiagnosisResult
            }
          }).then(res => {
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
      },
      saveData() {
        let that = this;
        that.$confirm("确认保存吗？", "提示", {}).then(() => {
          that.$axios({
            url: "/api/inquiry/medicalrecord/" + that.uData.reservationId,
            method: "POST",
            data: {
              "patientId": that.uData.pid,
              "doctorId": that.uData.did,
              "assistantExamination": that.diagnose.assistantExamination,
              "hpi": that.diagnose.hpi,
              "kexia": that.diagnose.kexia,
              "mainSuit": that.diagnose.mainSuit,
              "mdiagnosisResult": that.diagnose.mdiagnosisResult,
              "mdiseasesEn": that.diagnose.mdiseasesEn,
              "mdiseasesZh": that.diagnose.mdiseasesZh,
              "pulseCondition": that.diagnose.pulseCondition,
              "shetai": that.diagnose.shetai,
              "wdiagnosisResult": that.diagnose.wdiagnosisResult
            }
          }).then(res => {
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '保存成功'
              });
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消保存"
          });
        });
      },
      resetData() {                 // 重置按钮
        let that = this;
        that.$confirm("确认重置吗？", "提示", {}).then(() => {
          that.diagnose.assistantExamination = '';
          that.diagnose.hpi = '';
          that.diagnose.kexia = '';
          that.diagnose.mainSuit = '';
          that.diagnose.mdiagnosisResult = '';
          that.diagnose.mdiseasesEn = '';
          that.diagnose.mdiseasesZh = '';
          that.diagnose.pulseCondition = '';
          that.diagnose.shetai = '';
          that.diagnose.wdiagnosisResult = '';
          that.$message({
            type: "success",
            message: "已重置了哟"
          });
        }).catch(() => {
          that.$message({
            type: "info",
            message: "已取消保存"
          });
        });
      },
      getData(o){
        let that = this;
        that.uData = o;
        if(o.haveData == null){
          that.exhibition = false;
        }else{
          that.exhibition = true;
          that.repetitionId = o.haveData.medicalRecordId;
          that.diagnose.mainSuit = o.haveData.mainSuit;
          that.diagnose.hpi = o.haveData.hpi;
          that.diagnose.assistantExamination = o.haveData.assistantExamination;
          that.diagnose.kexia = o.haveData.kexia;
          that.diagnose.shetai = o.haveData.shetai;
          that.diagnose.pulseCondition = o.haveData.pulseCondition;
          that.diagnose.wdiagnosisResult = o.haveData.wDiagnosisResult;
          that.diagnose.mdiseasesZh = o.haveData.mDiseasesZh;
          that.diagnose.mdiseasesEn = o.haveData.mDiseasesEn;
          that.diagnose.mdiagnosisResult = o.haveData.mDiagnosisResult;
        }
      }
    },
  };
</script>

<style type="text/css" scoped>
    .inOne-TabRecords {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .inOne-records form {
        margin-bottom: 20px;
    }

    .inOne-NoRecords {
        border-bottom: none;
    }

    .inOne-TabRecords p {
        margin-top: 15px;
    }

    .inOne-TabRecords h3 {
        font-size: 18px;
    }

    .inOne-TabRecords textarea {
        color: #646a6b;
        height: 30px;
    }

    .headTitle {
        margin-top: 5px;
        margin-bottom: 10px;
    }

    .inOne-TabBttom {
        text-align: center;
    }

    .inOne-TabBttom h2 {
        padding-top: 20px;
        padding-left: 0;
        margin-right: 20px;
        cursor: pointer;
    }

    .zhenduan {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 10px;
        clear: both;
    }

    .zhenduan h4 {
        font-size: 24px;
        margin-bottom: 5px;
    }

    .zhenduan h5 {
        margin-top: 15px;
        margin-bottom: 10px;
    }

    .westernMedicine {
        font-size: 24px;
        margin-top: 15px;
        text-align: center;
    }

    .left_one {
        float: left;
        margin-right: 10px;
    }

    .right_one {
        float: right;
    }
</style>



// WEBPACK FOOTER //
// inquiryRecords.vue?066bfa47